import * as React from 'react';
import styled from 'styled-components';
import { SelectBox } from '../form/SelectBox';

interface IProps {
  is3d: boolean;
  velocityAvailable: boolean;
  onForceSelect: (val: boolean) => void;
  forceSelected: boolean;
  on3dSelected: (val: boolean) => void;
  threeDSelected: boolean;
  onVelocitySelected: (val: boolean) => void;
  velocitySelected: boolean;
  onDisplacementSelected: (val: boolean) => void;
  displacementSelected: boolean;
  onPowerSelected: (val: boolean) => void;
  powerSelected: boolean;
}

export const GraphMenu = (props: IProps): React.ReactElement => {
  const showForceHandler = (e: React.ChangeEvent<HTMLInputElement>): void =>
    props.onForceSelect(!!e.target.checked);

  const show3dHandler = (e: React.ChangeEvent<HTMLInputElement>): void =>
    props.on3dSelected(!!e.target.checked);

  const showVelocityHandler = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const isChecked = !!e.target.checked;
    props.onVelocitySelected(isChecked);
    if (isChecked) {
      props.onDisplacementSelected(false);
      props.onPowerSelected(false);
    }
  };

  const showDisplacementHandler = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const isChecked = !!e.target.checked;
    props.onDisplacementSelected(isChecked);
    if (isChecked) {
      props.onVelocitySelected(false);
      props.onPowerSelected(false);
    }
  };

  const showPowerHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const isChecked = !!e.target.checked;
    props.onPowerSelected(isChecked);
    if (isChecked) {
      props.onDisplacementSelected(false);
      props.onVelocitySelected(false);
    }
  };

  return (
    <MenuContainer>
      <Spacer>
        <SelectBox
          label='Force'
          onSelect={showForceHandler}
          selected={props.forceSelected}
        />
      </Spacer>

      {props.is3d && (
        <Spacer>
          <SelectBox
            label='3D'
            onSelect={show3dHandler}
            selected={props.threeDSelected}
          />
        </Spacer>
      )}
      {props.velocityAvailable && (
        <React.Fragment>
          <Spacer>
            <SelectBox
              label='Velocity'
              onSelect={showVelocityHandler}
              selected={props.velocitySelected}
            />
          </Spacer>
          <Spacer>
            <SelectBox
              label='Displacement'
              onSelect={showDisplacementHandler}
              selected={props.displacementSelected}
            />
          </Spacer>
          <Spacer>
            <SelectBox
              label='Power'
              onSelect={showPowerHandler}
              selected={props.powerSelected}
            />
          </Spacer>
        </React.Fragment>
      )}
    </MenuContainer>
  );
};

const MenuContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  @media print {
    display: none;
  }
`;

const Spacer = styled.div`
  margin-right: 5px;
`;
